import { Length, MaxLength, IsOptional, IsEmail, IsNumberString, MinLength } from 'class-validator';

export class UsuarioOnline {
    Login: string;
    Password: string;
    @Length(1, 100)
    Nombre: string;
    @MinLength(9)
    Telefono1: string;
    @IsOptional()
    @MinLength(9)
    Telefono2: string;
    @IsEmail()
    EMail: string;
    EFactura: boolean;
    UltimoPeriodoAvisado: string;
    FechaRegistro: Date;
    UltimoAcceso: Date;
    PenultimoAcceso: Date;
    ModoTest: boolean;
    DatePassword: Date;
    ReturnStatus: boolean;
    IsAuthenticated: boolean;
    @MinLength(3)
    Explotacion: string;
    RememberMe: boolean;
    Guid: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/UsuarioOnline.entity.ts